import React from "react";
import styles from "./DatabaseDetail.module.scss";
import { SonicEventData } from "../../../../common/classes/SonicEvent";
import DetailInfo from "../../../../common/management/detail/DetailInfo";
import {
  checkForJikeiRoles,
  secondsToTimeText,
  timestampToTime,
} from "../../../../utils/GeneralUtils";

type Props = {
  event: SonicEventData;
};
const EventDetailInfo: React.FC<Props> = ({ event }) => {
  return (
    <>
      <DetailInfo title="イベント名">{event.name}</DetailInfo>
      <DetailInfo title="イベントカテゴリ">{event.event_type.name}</DetailInfo>
      <DetailInfo title="開催日時">
        {`${
          event.start_date
            ? timestampToTime(event.start_date, false, false)
            : null
        } ${secondsToTimeText(event.start_time)}   -   ${
          event.end_date ? timestampToTime(event.end_date, false, false) : null
        } ${secondsToTimeText(event.end_time)}`}
      </DetailInfo>
      <DetailInfo title="イベント概要">{event.overview}</DetailInfo>
      <DetailInfo title="ゲームタイトル">
        {event.game && event.game.map((el) => el.name).join(`\n`)}
      </DetailInfo>
      <DetailInfo title="画像">
        {event.imgs && (
          <div>
            {event.imgs.map((img) => (
              <div className={styles["imageBox"]} key={img.id}>
                <img src={img.medium.url} />
              </div>
            ))}
          </div>
        )}
      </DetailInfo>
      <DetailInfo title="タグ">
        {event.tags && event.tags.map((el) => el).join(", ")}
      </DetailInfo>
      <DetailInfo title="配信情報" className="noFlex">
        {event.media &&
          event.media.map((el, i) => (
            <div key={i}>
              {`${el.name}：`}
              <a href={el.url} target="_blank" rel="noopener noreferrer">
                {el.url}
              </a>
            </div>
          ))}
      </DetailInfo>
      <DetailInfo title="住所">{event.address ?? ""}</DetailInfo>
      <DetailInfo title="アクセス方法">{event.direction ?? ""}</DetailInfo>
      <DetailInfo title="GoogleMap">{event.map ?? ""}</DetailInfo>
      <DetailInfo title="関連リンク" className="noFlex">
        {event.relatedLinks &&
          event.relatedLinks.map((el, i) => (
            <div key={i}>
              {`${el.name}：`}
              <a href={el.url} target="_blank" rel="noopener noreferrer">
                {el.url}
              </a>
            </div>
          ))}
      </DetailInfo>
      <DetailInfo title="表示設定">
        {checkForJikeiRoles(event.role_restriction) ? "学生限定" : "一般"}
      </DetailInfo>
    </>
  );
};

export default EventDetailInfo;
